module.exports = __webpack_public_path__ + "img/resumes-active.58ff1d3e.svg";